export default __webpack_public_path__ + "static/media/metarick.66842d47.jpeg";